import firebase from 'firebase/app';

export function getDisplayName(user) {
  return `${user.firstName || ''} ${user.lastName || ''}`.trim();
}

export function parseFullName(fullName = '') {
  const [firstName = '', lastName = ''] = (fullName || '').split(' ');
  return {
    firstName,
    lastName,
  };
}

export function isTestAccount(email) {
  if (!email) {
    return false;
  }

  const TEST_ACCOUNT_EMAIL_PATTERNS = [
    '(.+@ardas\\.(biz|ua|dp\\.ua))$',
    '(.+@fairviewtest\\.com)$',
    '(.+@fairview-ads\\.com)$',
  ];

  return TEST_ACCOUNT_EMAIL_PATTERNS.some((pattern) => new RegExp(pattern, 'gi').test(email));
}

export function isCurrentAccountTest() {
  return isTestAccount(firebase.auth().currentUser?.email);
}

export function getSignUpProvider(user) {
  return user?.providerData[0]?.providerId;
}

export function setAuthorizeStatus(status) {
  const user = firebase.auth().currentUser;

  if (!user) {
    return Promise.resolve();
  }

  return firebase.firestore().collection(`statuses`).doc(user.uid).set({
    authorized: status,
  });
}
